import { instanceOfGrid } from "../../../lib/grid/instanceOfGrid.js";
import "react";
import "@perxis-auto/shared/lib";
import "@perxis-auto/shared";
import "../../../lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../config/env.js";
import "../../../config/events.js";
import "../../../lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../lib/store/createAppApi.js";
import "../../../lib/store/createAppAsyncThunk.js";
import "../../../lib/store/createAppSelector.js";
import "../../../lib/store/createAppSlice.js";
import "redux";
import "../../../lib/store/hooks/useAppDispatch.js";
import "../../../lib/store/hooks/useAppSelector.js";
import "../../../lib/store/hooks/useAppStore.js";
function filterDisabledBlocksFields(fields, config) {
  var _a, _b;
  if (!((_a = config.benefits) == null ? void 0 : _a.enable)) {
    fields.delete("benefits");
    fields.delete("maxBenefit");
  }
  if (!((_b = config.tags) == null ? void 0 : _b.enable)) {
    fields.delete("tags");
  }
  return Array.from(fields);
}
function findFieldsInGridItems(items, fieldsGroup, fieldKey) {
  const fields = [];
  items.forEach((item) => {
    if (fieldKey === "fields" && item.fields && item.fields[fieldsGroup]) {
      fields.push(...item.fields[fieldsGroup]);
    }
    if (fieldKey === "referenceFields" && item.referenceFields && item.referenceFields[fieldsGroup]) {
      fields.push(...item.referenceFields[fieldsGroup]);
    }
    if (instanceOfGrid(item)) {
      fields.push(...findFieldsInGridItems(item.items, fieldsGroup, fieldKey));
    }
  });
  return Array.from(fields);
}
function getConstructorFields(constructorGrid, config, fieldsGroup, fieldKey) {
  var _a, _b;
  const fields = findFieldsInGridItems(constructorGrid.items, fieldsGroup, fieldKey);
  if (fieldKey === "fields") {
    return filterDisabledBlocksFields(
      /* @__PURE__ */ new Set([...((_a = constructorGrid.fields) == null ? void 0 : _a[fieldsGroup]) || [], ...fields]),
      config
    );
  }
  return filterDisabledBlocksFields(
    /* @__PURE__ */ new Set([
      ...((_b = constructorGrid.referenceFields) == null ? void 0 : _b[fieldsGroup]) || [],
      ...fields
    ]),
    config
  );
}
export {
  getConstructorFields
};
